// extracted by mini-css-extract-plugin
module.exports = {"videoGrid":"MyList_videoGrid__2-GiV"};